<template>
  <div class="data-holder performance">
    <div class="data-holder-inner">
      <div class="filter-holder row">
      </div>
    </div>
    <div class="slidein touch-scroll">
      <div class="data-content content">
        <div class="rotator-controls" v-if="item && item.id && !loading">
          <div class="new-rotator-select-container">
            <h1 class="headerone__default">
              <span class="bold__optional">Affiliate</span>
              <el-select v-if="!configured && $store.getters.isEmployee && !$store.state.user.affiliate_id" v-model="data.affiliate_id"
                  size="small" class="rotator-affiliate"
                  placeholder="Select Affiliate" popper-class="affiliate-select" @keydown.native="selectAffiliate"
                  filterable remote :remote-method="searchAffiliates" @focus="searchAffiliates('')"
                  no-match-text="No Matches" :loading="affLoading" loading-text="Loading...">
                <el-option v-for="affiliate in $store.state.cache.affiliateList" :v-if="affiliate.affiliate_id != 0"  :key="affiliate.affiliate_id"
                    :value="affiliate.affiliate_id" :label="affiliate.affiliate_id">
                  <span class="label">{{affiliate.label}}</span>
                  <span class="value">{{affiliate.affiliate_id}}</span>
                </el-option>
              </el-select>
              <span class="category" v-else>{{ data.affiliate_id }}</span>
            </h1>
            <h1 class="headerone__default">
              <span class="bold__optional">Vertical</span>
              <el-select class="new-rotator__selector" v-if="!configured" v-model="data.vertical" placeholder="Select Vertical" size="small" filterable>
                <el-option v-for="vert in $store.state.cache.vertList" :key="vert.id" :value="vert.name" :label="vert.name"></el-option>
              </el-select>
              <span class="category" v-else>{{ data.vertical }}</span>
            </h1>
            <h1 class="headerone__default">
              <span class="bold__optional">Geo</span>
              <el-select class="new-rotator__selector" v-if="!configured" v-model="data.country" placeholder="Select Country" size="small" popper-class="affiliate-select" filterable>
                <el-option v-for="geo in $store.state.cache.geoList" :key="geo.id" :value="geo.code" :label="geo.name">
                  <span class="label">{{geo.name}}</span>
                  <span class="value">{{geo.code}}</span>
                </el-option>
              </el-select>
              <span class="category" v-else>{{ countryName }}</span>
            </h1>
            <div class="launch-rotator-button-holder">
              <transition name="fade" mode="out-in">
                <el-button v-if="!isNew" type="primary" class="btn__default launch-radius-button hidden-sm-and-down" @click="radiusSetup(item.id)">
                    Bridge Page Setup
                </el-button>
              </transition>
            </div>
          </div>
          <transition name="fade" mode="out-in">
            <el-button v-if="!configured" type="primary" class="btn__default save-btn" @click="nextStepAdd">Continue</el-button>
            <div class="rotator-controls-info" v-else>
              <el-collapse v-model="activeTabs" ref="rotator-collapse">
                  <!-- Tracking Links -->
                <el-collapse-item title="Tracking Links" name="1">
                  <div class="tracking-link-container__default clearfix" v-for="(link, step, index) in data.tracking_links" :key="step">
                    <h2 class="headertwo__default header__column">{{ step.charAt(0).toUpperCase() + step.slice(1) }}</h2>
                    <div class="tracking-links__column">
                      <h2 class="headertwo__default">Rotator Tracking Link:</h2>
                      <div class="tracklink-static">{{ JBTrackingLinkBase }}&step={{ step.slice(4) }}</div>
                      <el-button type="info" size="mini" class="copy-btn__default" :class="{ copied: copied[index * 2] }" @click="copyToClipboard(index * 2)" plain>
                        {{ copied[index * 2] ? 'Copied !': 'Copy to Clipboard' }}
                      </el-button>
                      <textarea id="code-top-copy" class="hide-textarea" ref="copyTextarea">{{ JBTrackingLinkBase }}&step={{ step.slice(4) }}</textarea>
                      <h2 class="headertwo__default">3rd Party Tracking Link (Optional):</h2>
                      <el-input v-model="data.tracking_links[step]" :ref="'tracking-link-' + step" :placeholder="'https://your-' + step + '-tracking-link.com/click/'"></el-input>
                      <el-button type="info" size="mini" class="copy-btn__default" :class="{ copied: copied[index * 2 + 1] }" @click="copyToClipboard(index * 2 + 1)" plain>
                        {{ copied[index * 2 + 1] ? 'Copied !': 'Copy to Clipboard' }}
                      </el-button>
                      <textarea id="code-top-copy" class="hide-textarea" ref="copyTextarea">{{ data.tracking_links[step] || ' ' }}</textarea>
                      <div class="tracking-link__macro add-macro">
                        <span class="macro__title">Macros: </span>
                        <a class="macro__link" @click="data.tracking_links[step] = addMacro('tracking-link-' + step, 0, 'xxbpsxx')">Session ID</a> |
                        <a class="macro__link" @click="data.tracking_links[step] = addMacro('tracking-link-' + step, 0, 'xxprogidxx')">Campaign ID</a> |
                        <a class="macro__link" @click="data.tracking_links[step] = addMacro('tracking-link-' + step, 0, 'xxagentidxx')">Affiliate ID</a> |
                        <a class="macro__link" @click="addMacroPrompt(step, 'Name of the Query String parameter you want to pass:', 'yy')">Query String Parameter</a> |
                        <a class="macro__link" @click="addMacroPrompt(step, 'Name of the Javascript variable you want to pass:', 'zz')">Javascript Variable</a>
                      </div>
                    </div>
                  </div>
                </el-collapse-item>
                <!-- Campaign -->
                <el-collapse-item name="2">
                  <template slot="title">
                    Campaigns
                    <el-button @click.stop="collapseItemAdd('2', addCampaign)" size="medium">Add  <i class="el-icon-circle-plus"></i></el-button>
                  </template>
                  <div class="campaign-collection">
                    <draggable :list="data.campaigns" class="block__default" :options="{disabled: $isTouch}">
                      <transition-group :name="transition" :duration="$isTouch? 600: 400" tag="div">
                        <el-card v-for="(campaign, index) in data.campaigns" class="box-card row__default" :key="campaign.rand"
                              :class="[{'inactive': !isInRotation(campaign), 'employee-active': $store.getters.isEmployee}]">
                          <ul class="box-card-inner has-index">
                            <ul class="order-set order-change">
                              <li class="arrow arrow-up" @click="orderChange(data.campaigns, index, -1)" v-show="index > 0" style="cursor: pointer;"></li>
                              <li class="order-badge__default">{{ index + 1 }}</li>
                              <li class="arrow arrow-down" @click="orderChange(data.campaigns, index, 1)" v-show="index != data.campaigns.length - 1" style="cursor: pointer;"></li>
                            </ul>
                            <li class="column__default">
                              <p class="label__default">Campaign:</p>
                              <el-select filterable v-model="campaign.name" value-key="step1_campaign_id"
                                        :filter-method="(q) => (() => { searchCampaigns(campaign, q) })()" @change="(item) => (() => { setCampaign(index, item) })()" @focus="searchCampaigns(campaign, ''), getCampaignList()"
                                        no-data-text="No Matches" popper-class="sidebar-select" class="input__default select__default">
                                <el-option v-for="item in getCampaignOptions(campaign)" :key="item.step1_campaign_id" :label="item.step1_campaign_name" :value="item">
                                  <span class="label">{{ item.step1_campaign_name }}</span>
                                  <span class="value">{{ item.step1_campaign_id }}</span>
                                </el-option>
                              </el-select>
                            </li>
                            <li class="column__default">
                              <p class="label__default">Status:</p>
                              <el-select v-model="campaign.status" class="input__default select__default">
                                <el-option label="Enabled" value="active"></el-option>
                                <el-option label="Disabled" value="inactive"></el-option>
                              </el-select>
                            </li>
                            <li class="column__default">
                              <p class="label__default">Weight:</p>
                              <el-input v-model="campaign.weight" class="input__default" :disabled="hasWeightedWeightStrategy ? false : true"></el-input>
                            </li>
                            <ul class="exclusive__employee" v-if="$store.getters.isEmployee">
                              <li class="column__default">
                                <p class="label__default">Weekly Cap:</p>
                                <el-input v-model="campaign.weekly_cap" class="input__default"></el-input>
                              </li>
                              <li class="column__default">
                                <p class="label__default">Daily Cap:</p>
                                <el-input v-model="campaign.daily_cap" class="input__default"></el-input>
                              </li>
                              <li class="column__default">
                                <p class="label__default">Redirect:</p>
                                <el-input v-model="campaign.redirect_campaign_id" class="input__default"></el-input>
                              </li>
                            </ul>
                          </ul>
                          <div class="tools-collection__default" :class="(campaign.state && campaign.state.toLowerCase()) || 'default'">
                            <p class="status-content" v-if="campaign.state">Campaign {{ campaign.state }}<span v-if="!isInRotation(campaign)"> - Not In Rotation</span></p>
                            <el-button v-if="data.campaigns && data.campaigns.length > 1" type="primary" icon="el-icon-delete" @click="remove(data.campaigns, campaign)"></el-button>
                          </div>
                        </el-card>
                      </transition-group>
                    </draggable>
                  </div>
                </el-collapse-item>
                <!-- Strategies -->
                <el-collapse-item name="3">
                  <template slot="title">
                    <span class="hidden-md-and-down">Rotation </span>Strategies
                    <el-button @click.stop="collapseItemAdd('3', addNonMlStrategy)" size="medium">Add  <i class="el-icon-circle-plus"></i></el-button>
                  </template>

                  <div class="campaign-collection block__default">
                    <draggable :list="data.strategies" :options="{disabled: $isTouch}">
                      <transition-group :name="transition" :duration="$isTouch? 600: 400">
                        <el-card v-for="(strategy, index) in data.strategies" :key="strategy.rand" v-if="strategy.strategy != 'ml'"
                            class="box-card row__default">
                          <ul class="box-card-inner has-index">
                            <ul class="order-set order-change">
                              <li class="arrow arrow-up" @click="orderChange(data.strategies, index, -1)" v-show="index > (data.strategies.indexOf(mlStrategy) + 1)" style="cursor: pointer;"></li>
                              <li class="order-badge__default">{{ index + 1 }}</li>
                              <li class="arrow arrow-down" @click="orderChange(data.strategies, index, 1)" v-show="index < data.strategies.length - 1" style="cursor: pointer;"></li>
                            </ul>
                            <li class="column__default">
                              <p class="label__default">Strategy:</p>
                              <el-select v-model="strategy.strategy" class="input__default select__default" placeholder="Select Strategy" @change="resetStrategy(index)">
                                <el-option value="threshold" label="Blended EPC"></el-option>
                                <el-option value="maximize" label="Maximum EPC"></el-option>
                                <el-option value="minimize" label="Ordered"></el-option>
                                <el-option value="weighted" label="Weighted"></el-option>
                              </el-select>
                            </li>
                            <li v-if="strategy.strategy === 'threshold'">
                              <div class="column__default">
                                <p class="label__default">Required $ EPC:</p>
                                <el-input v-model="strategy.threshold" class="input__default" name="threshold" type="number"></el-input>
                              </div>
                            </li>
                            <li v-if="strategy.strategy === 'weighted'">
                              <div class="column__default">
                                <p class="label__default">Metric:</p>
                                <el-select v-model="strategy.optimal_metric" class="input__default" placeholder="Select Metric">
                                  <el-option value="weight" label="Weight"></el-option>
                                  <el-option value="conversion_rate" label="Conv Rate"></el-option>
                                  <el-option value="daily_cap" label="Remaining Daily CAP"></el-option>
                                  <el-option value="weekly_cap" label="Remaining Weekly CAP"></el-option>
                                  <el-option value="total_daily_cap" label="Total Daily CAP"></el-option>
                                  <el-option value="total_weekly_cap" label="Total Weekly CAP"></el-option>
                                  <el-option value="epc_out" label="EPC Out"></el-option>
                                </el-select>
                              </div>
                            </li>
                          </ul>
                          <div class="tools-collection__default">
                            <el-button v-if="nonMlStrategies.length > 1" type="primary" icon="el-icon-delete" @click="remove(data.strategies, strategy)"></el-button>
                          </div>
                        </el-card>
                      </transition-group>
                    </draggable>
                  </div>
                </el-collapse-item>
                <!-- Pixel Types -->
                <el-collapse-item name="4">
                  <template slot="title">
                    Pixels
                    <el-button @click.stop="collapseItemAdd('4', addPixel)" size="medium">Add  <i class="el-icon-circle-plus"></i></el-button>
                  </template>
                  <div class="campaign-collection block__default">
                    <transition-group :name="transition" :duration="$isTouch? 600: 400">
                      <div v-if="!data.pixels || data.pixels.length == 0" class="row__default non-draggable__default" key="no-data">
                        <div class="box-card-inner pixel">
                          There are no pixels attached to this rotator.
                        </div>
                      </div>
                      <el-card v-for="(pixel, index) in data.pixels" class="box-card row__default" :key="pixel.rand">
                        <ul class="box-card-inner pixel-container">
                          <li class="column__default column__default__short">
                            <p class="label__default">Type:</p>
                            <el-select v-model="pixel.type" class="input__default select__default">
                              <el-option label="HTML/JS" value="html"></el-option>
                              <el-option label="Postback" value="postback">Postback</el-option>
                            </el-select>
                          </li>
                          <li class="column__default column__default__wide" v-if="pixel.type != ''">
                            <p class="label__default">Code:</p>
                            <el-input v-if="pixel.type == 'html'" v-model="pixel.code" type="textarea" class="input__default" ref="pixel"
                                placeholder="&lt;iframe src=&quot;https://your-pixel-url.com?sid=xxsidxx&quot;&gt;&lt;/iframe&gt;">
                            </el-input>
                            <el-input v-else v-model="pixel.code" class="input__default" ref="pixel"
                                placeholder="https://your-pixel-url.com?sid=xxsidxx">
                            </el-input>
                            <div class="tracking-link__macro add-macro">
                              <span class="macro__title">Macros: </span>
                              <a class="macro__link" @click="pixel.code = addMacro('pixel', index, 'xxprogidxx')">Campaign ID</a> |
                              <a class="macro__link" @click="pixel.code = addMacro('pixel', index, 'xxagentidxx')">Affiliate ID</a> |
                              <a class="macro__link" @click="pixel.code = addMacro('pixel', index, 'xxhitidxx')">Hit ID</a> |
                              <a class="macro__link" @click="pixel.code = addMacro('pixel', index, 'xxc1xx')">C1</a> |
                              <a class="macro__link" @click="pixel.code = addMacro('pixel', index, 'xxc2xx')">C2</a> |
                              <a class="macro__link" @click="pixel.code = addMacro('pixel', index, 'xxc3xx')">C3</a>
                            </div>
                          </li>
                        </ul>
                        <div class="tools-collection__default">
                          <el-button type="primary" icon="el-icon-delete" @click="remove(data.pixels, pixel)"></el-button>
                        </div>
                      </el-card>
                    </transition-group>
                  </div>
                </el-collapse-item>
              </el-collapse>
              <el-button type="primary" @click="save()" class="btn__default save-btn">
                <template v-if="!saveLoading">
                  {{ isNew ? 'Add New Rotator' : 'Save Changes' }}
                </template>
                <div v-else class="el-loading-spinner save-btn-spinner">
                  <svg viewBox="25 25 50 50" class="circular">
                    <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                  </svg>
                </div>
              </el-button>
            </div>
          </transition>
        </div>
        <p class="message" v-if='message'>{{ message }}</p>
      </div>
    </div>
    <transition name="fade" mode="out-in" v-if="typeof(item) == 'string' || loading">
      <div class="campaign-loader">
        <div class="el-loading-spinner">
          <svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
          </svg>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import pickerShortcuts from './picker-shortcuts'
import $ from 'jquery'
import datejs from '../static/js/date.js'
import draggable from 'vuedraggable'
import { Notification } from 'element-ui'
import Radius from './radius.vue'

export default {
  name: 'rotator',
  props: ['item'],
  data() {
    return {
      loading        : true,
      affLoading     : false,
      saveLoading    : false,
      isNextStep     : false,
      request        : null,
      previousItem   : null,
      enableML       : false,
      data           : {},
      transition     : '',
      campaignList   : [],
      campaignSearch : null,
      activeTabs     : this.$store.state.user.preferences.rotatorTabs.concat([]),
      windowWidth    : document.documentElement.clientWidth,
      copied         : { 0 : false, 1: false, 2: false, 3: false}
    };
  },
  created() {
    this.$store.dispatch('retrieveGeoList')
    this.$store.dispatch('retrieveVertList')
  },
  computed: {
    message() {
      if (!this.item)
        return 'Please select a rotator from the list on the left.';

      if (this.isNew)
        return false

      if (this.loading)
        return ' ';

      if (!this.loading && !this.data)
        return 'No info available for this rotator.';

      return false;
    },
    countryName() {
      const country = (this.$store.state.cache.geoList || []).find((geo) => {
        return this.data.country && this.data.country.toUpperCase() == geo.code.toUpperCase()
      })

      return country && country.name || this.data.country
    },
    mlStrategy() {
      if (!this.data || !this.data.strategies)
        return null;

      return this.data.strategies.find((strategy) => strategy.strategy === 'ml')
    },
    nonMlStrategies() {
      if (!this.data || !this.data.strategies)
        return [];

      return this.data.strategies.filter((strategy) => strategy.strategy !== 'ml')
    },
    trackingLinks() {
      if (this.data && this.data.tracking_links)
        return this.data.tracking_links

      return {
        'step1': '',
        'step2': ''
      }
    },
    hasWeightedWeightStrategy() {
      return this.data.strategies.some((strategy) => strategy.strategy == 'weighted' && strategy.optimal_metric == 'weight')
    },
    isNew() {
      return this.item && this.item.id == 'create'
    },
    configured() {
      return this.item && (!this.isNew || this.isNextStep) && this.data.affiliate_id
    },
    selectedCampaigns() {
      const selectedOptionArrays = {}
      this.data.campaigns.forEach(campaign => {
        selectedOptionArrays[campaign.campaign_id] = [{
          step1_campaign_id   : campaign.campaign_id,
          step1_campaign_name : campaign.name,
          state               : campaign.state
        }]
      })

      return selectedOptionArrays
    },
    availableCampaigns() {
      return (this.campaignSearch == '' || !this.campaignSearch
            ? this.campaignList.filter(v => ['active', 'capped'].indexOf(v.state.toLowerCase()) !== -1)
            : this.campaignList.filter(v => {
              return (v.step1_campaign_name).toLowerCase().indexOf(this.campaignSearch) !== -1
                  || (v.step1_campaign_id).toLowerCase().indexOf(this.campaignSearch) !== -1
            })
      ).filter(v => !this.data.campaigns.some(c => v.step1_campaign_id == c.campaign_id)).slice(0, 50);
    },
    JBTrackingLinkBase() {
      return 'https://optimizer.jbxroute.com/rd/r.php?pub=' + this.data.affiliate_id + '&geo=' + this.data.country.toLowerCase() + '&vert=' + this.data.vertical.toLowerCase()
    }
  },
  watch: {
    item() {
      this.isNextStep = false

      if (!this.item || !this.item.id) {
        this.$store.commit('setData', {})

      } else if ((this.item && !this.previousItem) || (!this.item && this.previousItem) || this.item.id != this.previousItem.id || this.item.id == 'create') {
        this.campaignList = []
        this.getRotator()

      }
    },
    '$store.state.rotator.data'(newVal) {
      this.transition = ''

      // Add random keys to all lists to use as vue keys
      const rotator = JSON.parse(JSON.stringify(newVal || {}))
      Object.values(rotator).forEach((list) => {
        if (list instanceof Array && list && list[0] instanceof Object)
          list.map((item) => { item.rand = item.rand || Math.random() })
      })

      this.data     = rotator
      this.enableML = !!this.mlStrategy
      this.getCampaignList()

      setTimeout(() => {
        if (!this.item || this.item.id == this.data.id) {
          this.transition = 'list'
          this.loading    = false
        }
      }, 300)
    },
    '$store.state.cache.affiliateList'() {
      this.affLoading = false
    },
    activeTabs(newVal){
      this.$store.commit('setPreference', { name: 'rotatorTabs', value: newVal.concat([]) })
    }
  },
  methods: {
    remove(list, target) {
      var index = list.indexOf(target)
      if (index !== -1)
        list.splice(index, 1)
    },
    nextStepAdd() {
      const missing = []

      if (!this.data.country)
        missing.push('Geo')

      if (!this.data.vertical)
        missing.push('Vertical')

      if (!this.data.affiliate_id || this.data.affiliate_id == 0)
        missing.push('Affiliate ID')

      if (missing.length) {
        return Notification.error({
          title    : 'Error',
          message  : missing.join(", ") + ' must be set',
          position : 'bottom-right'
        })
      }

      const existingRotator = this.getExistingRotator()
      if (existingRotator) {
        Notification.error({
          title    : 'Error',
          message  : 'The Rotator you are trying to create already exists. You will be redirected to it.',
          position : 'bottom-right'
        })
        return this.$router.replace({ name: 'rotator_id', params: { id: existingRotator.id }})
      }

      this.isNextStep = true
      this.getCampaignList()
    },
    getExistingRotator() {
      // Check for duplicate rotator matching current settings
      return this.$store.state.cache.rotators.find((rotator) => {
        return rotator.affiliate_id.toUpperCase() == this.data.affiliate_id.toUpperCase() &&
               rotator.country.toUpperCase() == this.data.country.toUpperCase() &&
               rotator.vertical.toUpperCase() == this.data.vertical.toUpperCase()
      })
    },
    collapseItemAdd(index, addItemCallback, child = 'last-child') {
      const isExpanded = this.activeTabs.indexOf(index) !== -1
      if (!isExpanded)
        this.activeTabs.push(index)

      addItemCallback()
      setTimeout(() => {
        const $container = $('.slidein'),
          $lastChild     = $('.el-collapse-item').eq(index-1).find('.box-card:' + child)

        // If on mobile, always move the new item to the top of the window
        if (this.$isTouch)
          this.$scrollTo.scrollTo('.el-collapse-item:nth-child(' + index + ') .box-card:' + child, 200, { container: '.content-panel .data-content', offset: -50 })
        // If on desktop, move the scroll position to just enough to ensure the new item is visible
        else if ($lastChild.offset()['top'] + ($lastChild.outerHeight() * 2) > window.innerHeight)
          $container.scrollTop($lastChild.position()['top'] - (window.innerHeight - $lastChild.outerHeight() * 2))
      }, isExpanded? 50: 400)
    },
    isInRotation(campaign) {
      return !(!campaign || !campaign.status || campaign.status.toLowerCase() === 'inactive' || !campaign.state || campaign.state.toLowerCase() !== 'active')
    },
    setCampaign(index, campaign) {
      Object.assign(this.data.campaigns[index], {
        name        : campaign.step1_campaign_name,
        campaign_id : campaign.step1_campaign_id,
        state       : campaign.state
      })
    },
    addCampaign(data = this.data) {
      data.campaigns.push({
        'rand'                 : Math.random(),
        'campaign_id'          : null,
        'status'               : 'active',
        'state'                : null,
        'weight'               : 1,
        'redirect_campaign_id' : null,
        'daily_cap'            : null,
        'weekly_cap'           : null
      });
    },
    addPixel(data = this.data) {
      data.pixels.push({
        'rand' : Math.random(),
        'type' : 'html',
        'code' : ''
      });
    },
    addMlStrategy(data = this.data) {
      if (!this.mlStrategy) {
        data.strategies = [{
          'rand'               : Math.random(),
          'strategy'           : 'ml',
          'traffic_allocation' : 50,
          'optimal_metric'     : 'device',
          'suboptimal_metric'  : null
        }].concat(data.strategies);
      }
    },
    addNonMlStrategy(data = this.data) {
      data.strategies.push({
        'rand'               : Math.random(),
        'strategy'           : 'minimize',
        'traffic_allocation' : 100,
        'optimal_metric'     : 'rank',
        'suboptimal_metric'  : null
      });
    },
    getCampaignOptions(campaign) {
      return (campaign && campaign.campaign_id
            ? this.selectedCampaigns[campaign.campaign_id]
            : []
      ).concat(this.availableCampaigns)
    },
    getCampaignList() {
      if (!this.configured) return

      this.$http.get(this.$store.getters.baseEndpoint + 'affiliate/' + this.data.affiliate_id + '/country/' + this.data.country + '/vertical/' + this.data.vertical + '/campaigns')
          .then((response) => this.campaignList = JSON.stringify(response.data.data) !== JSON.stringify(this.campaignList)? response.data.data: this.campaignList)
          .catch((error) => {
            if (this.$http.isApiError(error))
              this.campaignList = []
          })
    },
    getRotator() {
      this.loading      = true
      this.previousItem = this.item
      this.$store.commit('setRotatorId', this.item.id)

      if (this.isNew) {
        const data = {
          id           : 'create',
          affiliate_id : this.$store.state.user.affiliate_id,
          country      : '',
          vertical     : '',
          pixels       : [],
          campaigns    : [],
          strategies   : [],
          tracking_links: {
            'step1': '',
            'step2': ''
          },
        }

        this.addCampaign(data)
        this.addNonMlStrategy(data)
        this.$store.commit('setData', data)
      } else {
        this.$store.dispatch('getRotator')
      }
    },
    rotatorSaveResponse(response) {
      this.$store.commit('setData', this.data)
      this.$store.dispatch('retrieveRotators');

      Notification({
        title    : 'Success',
        message  : 'Successfully saved!',
        type     : 'success',
        position : 'bottom-right'
      })
      this.saveLoading = false
    },
    rotatorSaveError(error) {
      let message  = 'Something went wrong, please try again.'

      if (this.$http.isApiError(error)) {
        message = error.response.data._meta.errors.join(", ")

        if (error.response.data._meta.errors.type == 'ROTATOR_EXISTS') {
          message = 'The Rotator you are trying to create already exists. You will be redirected to it.'
          this.$router.replace({ name: 'rotator_id', params: error.response.data._meta.errors.rotator_id })
        }
      }

      Notification.error({
        title    : 'Error',
        message  : message,
        position : 'bottom-right'
      })
      this.saveLoading = false
    },
    save() {
      // Don't allow duplicate submits
      if (this.saveLoading)
        return

      this.saveLoading = true

      if (this.isNew) {
        this.$http.post(this.$store.getters.baseEndpoint + 'affiliate/' + this.data.affiliate_id + '/rotator', this.data)
            .then((response) => this.rotatorSaveResponse(response))
            .catch((error) => this.rotatorSaveError(error))
      } else {
        this.$http.put(this.$store.getters.baseEndpoint + 'affiliate/' + this.data.affiliate_id + '/rotator/' + this.data.id, this.data)
            .then((response) => this.rotatorSaveResponse(response))
            .catch((error) => this.rotatorSaveError(error))
      }
    },
    radiusSetup(id) {
      this.$router.push({ name: 'setup', params: { id }})
    },
    searchAffiliates(q) {
      if (this.data && this.$store.state.cache.affiliateList.length > 1 &&
          (!q || this.data.affiliate_id.toLowerCase() == q.toLowerCase()))
        return

      this.affLoading = true
      this.$store.dispatch('searchAffiliates', q || '')
    },
    selectAffiliate(e) {
      if (e.keyCode == 13)
        $('.rotator-affiliate li.hover:eq(0)').length
      ? $('.rotator-affiliate li.hover:eq(0)').click()
      : $('.rotator-affiliate li:visible:eq(0)').click()
    },
    resetStrategy(num){
      const metricDefaults = {
        'threshold': 'epc_out',
        'weighted' : 'weight',
        'minimize' : 'rank',
        'maximize' : 'epc_out'
      }
      const thresholdDefaults = {
        'threshold': '5.00'
      }
      Object.assign(this.data.strategies[num], {
        optimal_metric    : metricDefaults[this.data.strategies[num].strategy] || null,
        suboptimal_metric : null,
        threshold         : thresholdDefaults[this.data.strategies[num].strategy] || null
      })
    },
    addMacro(ref, index, macro) {
      let el = $('input,textarea', this.$refs[ref][index || 0].$el)[0]
      let endPos = el.selectionEnd

      this.$nextTick(() => this.$nextTick(() => { this.setCaretPosition(el, endPos + macro.length) }))
      return el.value.slice(0, endPos) + macro + el.value.slice(endPos)
    },
    addMacroPrompt(step, message, prefix) {
      const tip = "This feature will allow you to pass dynamic values from your landing page through to your redirect link. <br/><br/>"
      this.$prompt(tip + message, 'Dynamic Macro', {
        inputPattern: /^[\w\-\.\~%\$]+?$/,
        inputErrorMessage: 'Invalid variable name',
        confirmButtonText: 'Add',
        cancelButtonText: 'Cancel',
        dangerouslyUseHTMLString: true
      }).then(value => {
        this.data.tracking_links[step] = this.addMacro('tracking-link-' + step, 0, prefix + value.value + prefix)
      }).catch(() => {})
    },
    setCaretPosition(element, position) {
      if (element.createTextRange) {
        var range = element.createTextRange()
        range.move('character', position)
        range.select()
      } else if (element.selectionStart) {
        element.focus()
        element.setSelectionRange(position, position)
      }
    },
    searchCampaigns(campaign, q) {
      this.campaignSearch = !campaign || q == campaign.name ? '' : q.toLowerCase()
    },
    copyToClipboard(index) {
      try {
        const copyText = this.$refs.copyTextarea[index]

        if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
          var range = document.createRange()
          range.selectNodeContents(copyText)
          var sel = window.getSelection()
          sel.removeAllRanges()
          sel.addRange(range)
          copyText.setSelectionRange(0, 999999)
        } else {
          copyText.select()
        }
  
        document.execCommand("Copy")
        copyText.blur()
        
        this.copied = { 0: false, 1: false, 2: false, 3: false}
        this.copied[index] = true
        setTimeout(() => this.copied[index] = false, 2000)
      } catch (err) {
        console.error('Failed to copy step' + index + ' JB tracking link.')
      }
    },
    getWindowWidth() {
      this.windowWidth = document.documentElement.clientWidth;
    },
    orderChange(list, currentIndex, positionChange) {
      const element = list.splice(currentIndex, 1)[0]
      list.splice(currentIndex + positionChange, 0, element)
    }
  },
  mounted() {
    if (this.item && this.item.id)
      this.getRotator()
    else if (!this.item)
      setTimeout(() => !this.item && this.$store.commit('setData', {}), 300)

    window.addEventListener('resize', this.getWindowWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
  },
  components: {
    draggable, Radius
  }
}
</script>

<style lang="scss">
@media(max-width: 736px){
  .tracking-link-container__default {
    input.el-input__inner {
      padding-right: 0 !important;
    }
  }
}
</style>
<style scoped lang="scss">

@import '~static/mixins/global';
@import '~static/mixins/variables';

h1 {
  margin-bottom: 12px;
  color: #111;
}
h2 {
  color: #555;
}
.message {
  min-height: 300px;
  padding: 150px 0;
  text-align: center;
  background: #F1F1F1;
  border-radius: 5px;
  font-size: 16px;
  color: #777;
}
.rotator-view{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.required-field{
  font-size: 12px;
  font-weight: normal;
  color: red;
}
/*====
 *
 ** Control Styles
 *
   ====*/
.campaign-loader{
  position: absolute;
  top: 50px;
  left: 0;
  background: #fff;
  width: 100%;
  height: 100%;
  .el-icon-loading{
    position: absolute;
    top: calc(50%);
    left: calc(50%);
  }
}

.headerone__default{
  font-size: 17px;
  height: 32px;
  font-family: $font-family-interface;
  line-height: 32px;
  margin-bottom: 4px;

  .bold__optional {
    width: 80px;
  }

  .el-select {
    width: 150px;
  }

  .category {
    color: #555;
    display: inline-block;
    font-size: inherit;
    padding: 0 15px;
    font-size: 14px;
  }
}
.headertwo__default{
  font-size: 14px;
  font-family: $font-family-interface;
  line-height: normal;
  margin-bottom: 0px;
  color: #000;
}
.bold__optional{
  font-weight: bold;
  text-align: right;
}
.block__default{
  margin: 15px 0;
  cursor: move;
}
.row__default
{ /*ROW DEFAULT*/
  border: none;
  box-shadow: 0 1px 1px 0 rgba(0,0,0, .2);
  margin: 10px 0;
  border-radius: 0;
  padding: 20px 0 0 0;
  position: relative;
  background: #fff;
  transition: all .6s;
  min-height: 96px;
  overflow: auto;
  &.inactive {
    background: #e1e1e1;

    /deep/ .el-input.is-disabled .el-input__inner {
      background: #e1e1e1;
    }
  }

  &.list-leave-active {
    min-height: 0px;
    height: 0;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  &.column-half__padding{
    padding: 13px 13px 1px 13px;
  }

  &:after{
    content: '';
    clear: both;
    display: block;
  }
  .status-content{
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    left: 10px;
    line-height: 28px;
    font-size: 13px;
  }
  .box-card-inner{
    margin: 0 0 17px 0;
    position: relative;
    padding: 0 10px;

    &.pixel-container{
      .column__default__short{
        width: 20%;
      }
      .column__default__wide{
        width: 80%;
      }
    }

    &.has-index{
      padding: 0 10px 0 25px;
    }
    &.pixel {
      text-align: center;
      font-size: 14px;
      line-height: 60px;
    }
    &:after{
      content: '';
      display: block;
      clear: both;
    }
  }
  .order-set{
    .order-badge__default{
      left: 10px;
      font-size: 13px;
      width: 15px;
      height: 15px;
      border-radius: 100%;
      background: #ccc;
      color: #fff;
      line-height: 17px;
      text-align: center;
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      position: absolute;
    }
    .arrow{
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 12px;
      display: none;
    }
    .arrow-up {
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;

      border-bottom: 8px solid #ccc;

      top: -40px;
    }
    .arrow-down {
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;

      border-top: 8px solid #ccc;

      bottom: -40px;
    }
  }
  .el-button--primary{
    position: absolute;
    top: 0;
    bottom: 0;
    right: 10px;
    background: transparent;
    color: grey;
    padding: 0;
    border: none;

    &.is-disabled {
      color: #c0c4cc;
      border-color: #ebeef5;
    }
  }
  .tools-collection__default{
    position: relative;
    padding: 13px;
    margin: 0;
    width: 100%;
    color: #fff;
    background-color: #f3f3f3;

    &.default {
      color: #000;

      .el-button--primary {
        color: #000;
      }
    }
    &.expired {
      background-color: #303133;
      .el-button--primary {
        color: white;
      }
    }
    &.not {
      background-color: #ff4949;
    }
    &.paused {
      background-color: #909399;
      .el-button--primary {
        color: white;
      }
    }
    &.capped {
      background-color: #E6A23C;
      .el-button--primary {
        color: white;
      }
    }
    &.active {
      background-color: #13ce66;
      .el-button--primary {
        color: white;
      }
    }
  }
}
.save-btn {
  margin: 40px auto;
  width: 165px;
  text-align: center;
  display: block;

  .el-loading-spinner {
    position: relative;
    height: 14px;
    margin: 0;
    top: -8px;
  }
  .el-loading-spinner .circular {
    display: inline-block;
    overflow: hidden;
    height: 30px;
    width: 30px;
  }
  .el-loading-spinner .path {
    stroke: #fff;
  }
}
.employee-active {
  .column__default:nth-child(2) {
    width: 25%;
  }
  .column__default:nth-child(n+3),
  .exclusive__employee .column__default {
    width: 15%;
  }
}
.ml {
  .box-card-inner {
    margin-bottom: 0px;
  }
  .column--title {
    line-height: 60px;
    font-size: 15px;
    overflow: hidden;
    white-space: nowrap;
  }

  .column--content {
    margin-bottom: 20px;
  }

  .order-badge__default {
    top: -17px !important;
  }
}
.column__default {
  width: 50%;
  float: left;
  position: relative;
  padding: 0 10px;
  &:nth-child(n+3) {
    width: 25%;
  }
  &.column--title {
    width: 25%;
  }
  &.column--content {
    width: 75%;
  }
  p {
    white-space: nowrap;
  }
}

.label__default{
  margin-bottom: 4px;
  font-size: 13px;
  line-height: 13px;
}
.content-group{
  margin: 15px 0 0 0;
  padding: 0 15px;
  clear: both;
  border-radius: 0;
  .non-draggable__default{
    margin: 0 0 15px 0;

    .headerone__default{
      margin-bottom: 15px;
    }

    &.ml {
      .column--title {
        line-height: 60px;
        font-size: 15px;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
}
.tracking-link-container__default{
  background: #fff;
  padding: 20px 20px 0 0;
  margin: 10px 0;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2);

  .header__column,
  .tracking-links__column{
    display: inline-block;
    vertical-align: top;
  }
  .headertwo__default{
    font-weight: bold;
    color: #333 ;
  }
  .header__column{
    width: 14%;
    text-align: center;
    color: #000;
  }
  .tracking-links__column{
    width: 85%;
  }
  .hide-textarea{
    height: 0;
    overflow: hidden;
    opacity: 0;
  }
  .tracking-link__macro{
    margin-bottom: 25px;
  }
  .tracklink-static{
    margin-top: 11px;
    width: 100%;
    word-break: break-all;
    border-bottom: 1px solid #ccc;
    color: #606266;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    padding: 0 25px 0 0;
    font-family: system-ui;
    font-weight: 100;
    overflow: hidden;
  }
  .copy-btn__default{
    top: -36px;
    margin-bottom: -40px;
    text-align: center;
    width: 150px;
    transition: all 0.5s, background-color 0.3s;

    &.copied {
      background-color: #67C23A;
      color: #fff;
    }
  }
}
.tracking-link-container__default{
  background: #fff;
  padding: 20px 20px 0 0;
  margin: 10px 0;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2);

  .header__column,
  .tracking-links__column{
    display: inline-block;
    vertical-align: top;
  }
  .headertwo__default{
    font-weight: bold;
    color: #333 ;
  }
  .header__column{
    width: 14%;
    text-align: center;
    color: #000;
  }
  .tracking-links__column{
    width: 85%;
  }
  .hide-textarea{
    height: 0;
    overflow: hidden;
    opacity: 0;
  }
  .tracking-link__macro{
    margin-bottom: 25px;
  }
  .tracklink-static{
    margin-top: 11px;
    width: 100%;
    word-break: break-all;
    border-bottom: 1px solid #ccc;
    color: #606266;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    padding: 0 25px 0 0;
    font-family: system-ui;
    font-weight: 100;
    overflow: hidden;
  }
  .copy-btn__default{
    top: -36px;
    margin-bottom: -40px;
    text-align: center;
    width: 150px;
    transition: all 0.5s, background-color 0.3s;

    &.copied {
      background-color: #67C23A;
      color: #fff;
    }
  }
}
.launch-rotator-button-holder{
  position: absolute;
  top: calc(100% / 2 - 32px);
  right: 30px;
}
.sdk-content-parent{
  .sdk-content{
    font-family: $font-family-interface;
    font-size: 13px;
    margin-top: -13px;
    position: relative;
    top: 2px;
  }
  .error{
    color: red;
  }
  .success{
    color: #67C23A;
  }
}

.affiliate-select {
  .value {
    float: right;
    color: #8492a6;
    font-size: 13px;
  }
  .label {
    float: left;
    width: 225px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .selected .value {
    color: #e5e5e5;
  }
}

.add-macro {
  .macro__title {
    padding-right: 10px;
  }

  .macro__link {
    cursor: pointer;
    padding: 0 2px;
    color: #3366BB;
  }

  .macro__link:hover {
    text-decoration: underline;
  }

}
@media(max-width: 736px){
  .column__default {
    width: 100% !important;
    float: none;
    margin: 20px 0;
    &:nth-child(n+3) {
      width: 100%;
    }
    &.column--title {
      width: 100%;
      margin-top: 0px;
    }
  }
  .employee-active {
    .column__default:nth-child(2) {
      width: 100%;
    }
    .column__default:nth-child(n+3),
    .exclusive__employee .column__default {
      width: 100%;
    }
  }
  .row__default{
    .order-set{
      .arrow{
        display: block;
      }
    }
  }

  .headerone__default {
    height: auto;
    .bold__optional {
      text-align: left;
      margin-left: 0px;
    }

    .new-rotator__selector {
      width: calc(100% - 85px);
      max-width: 150px;
    }
  }

  .tracking-link-container__default {
    padding: 24px;
    .header__column {
      text-align: left;
      width: 100%;
      font-size: 15px;
      margin-bottom: 8px;
    }
    .tracking-links__column {
      width: 100%;
    }
    .tracklink-static {
      padding: 0;
    }
    .copy-btn__default {
      top: 7px;
      margin: 0;
      width: 100%;
    }
  }
  .macro__title {
    display: block;
  }
}
@media(min-width: 1024px){
  .data-holder{
    right: 0 !important;
    position: relative;
    margin-left: 375px !important;
    width: auto;
    height: inherit;
  }

}
</style>



// WEBPACK FOOTER //
// rotator.vue?6ab1b358